import appStore from 'store'
import api from './api'
import { QUERY_TYPE, PAGINATION } from './constants'

const store = {
  namespaced: true,
  state: {
    userList: [],
    detailList: [],
    coinList: [],
    totalCount: 0,
    detailTotalCount: 0,
    pagination: PAGINATION,
  },
  getters: {},
  mutations: {
    setUserList(state, payload) {
      state.userList = payload.records
      state.totalCount = payload.total
    },
    setPagination(state, payload) {
      state.pagination = payload
    },
  },
  actions: {
    list({ commit }, query = {}) {
      commit('setPagination', { page: query.page, size: query.size })
      api.getUserList(query).then((res) => {
        if (res.code == 0) {
          commit('setUserList', res.data)
        }
      })
    },
  },
}

appStore.registerModule('transferRecord', store)
